import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    invitations: [],
    loading: false,
  }),
  mutations: {
    setInvitations(state, invitations) {
      state.invitations = invitations
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchInvitations(context) {
      withLoading(async () => {
        try {
          const response = await api.get("/manage/invitations")
          context.commit("setInvitations", response.data)
        } catch (error) {
          // Отказ загрузки — пустой список: экран показывает
          // «Ссылки регистрации не найдены».
          context.commit("setInvitations", [])
        }
      }, context)
    },

    async createInvitation(context, params) {
      withLoading(async () => {
        const response = await api.post("/manage/invitations", params)
        context.commit("setInvitations", response.data)
      }, context)
    },

    async updateInvitation(context, { id, active }) {
      withLoading(async () => {
        const response = await api.put(`/manage/invitations/${id}`, { active })
        context.commit("setInvitations", response.data)
      }, context)
    },

    async deleteInvitation(context, id) {
      withLoading(async () => {
        const response = await api.delete(`/manage/invitations/${id}`)
        context.commit("setInvitations", response.data)
      }, context)
    }
  }
}